const TAIICHI_OHNO = 'Taiichi Ohno - Father of the Toyota Production System';
const HENRY_FORD = 'Henry Ford - Founder of the Ford Motor Company';
const ED_DEMING = 'Edward Deming - Creator of PDCA';

export const HAVING_NO_PROBLEMS = 'Having no problems is the biggest problem of all.';
export const HAVING_NO_PROBLEMS_SOURCE = TAIICHI_OHNO;

export const FORCE_STANDARDS = 'Standards should not be forced down from above but rather set by the production workers themselves.';
export const FORCE_STANDARDS_SOURCE = TAIICHI_OHNO;

export const WASTE = 'Waste is anything other than the minimum amount of equipment, materials, parts, space and worker\'s time, which are absolutely essential to add value to the product.';
export const WASTE_SOURCE = TAIICHI_OHNO;

export const ALWAYS_DO_WHAT_ALWAYS_DID = 'If you always do what you always did, you’ll always get what you’ve always got.';
export const ALWAYS_DO_WHAT_ALWAYS_DID_SOURCE = HENRY_FORD;

export const FIND_FAULT = 'Don\'t find fault, find a remedy; anybody can complain.';
export const FIND_FAULT_SOURCE = HENRY_FORD;

export const BAD_SYSTEM = 'A bad system will beat a good person every time.';
export const BAD_SYSTEM_SOURCE = ED_DEMING;

export const WITHOUT_DATA = 'Without data, you\'re just another person with an opinion.';
export const WITHOUT_DATA_SOURCE = ED_DEMING;

export default {
  HAVING_NO_PROBLEMS,
  HAVING_NO_PROBLEMS_SOURCE,
  FORCE_STANDARDS,
  FORCE_STANDARDS_SOURCE,
  WASTE,
  WASTE_SOURCE,
  ALWAYS_DO_WHAT_ALWAYS_DID,
  ALWAYS_DO_WHAT_ALWAYS_DID_SOURCE,
  FIND_FAULT,
  FIND_FAULT_SOURCE,
  BAD_SYSTEM,
  BAD_SYSTEM_SOURCE,
  WITHOUT_DATA,
  WITHOUT_DATA_SOURCE,
}
